import { WebPaymentTypeEnum } from '@up/data';
import { IsNumber, IsObject, IsString } from 'class-validator';

export class DigitalWalletPaymentRequestDto {
  @IsString()
  authorizationToken: string;

  @IsNumber()
  orderId?: number;

  @IsString()
  walletToken: string;

  @IsString()
  walletId?: string;

  @IsNumber()
  paymentId?: number;

  @IsString()
  customerId?: string;

  @IsString()
  paymentSolutionId?: string;

  @IsObject()
  webPaymentType?: WebPaymentTypeEnum;
}
